module.exports = require("././angular.js");


//////////////////
// WEBPACK FOOTER
// angular (bower component)
// module id = 28
// module chunks = 0 1